import { MailTemplateDocument } from "@onpreo/database";

export type MailTemplateState = {
    templates: MailTemplateDocument[];
};
export const initialMailTemplateState = {
    templates: []
};
